import { Component, Inject } from '@angular/core';
import { AttachmentType } from '../../_types/generic.type';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../_services/alert.service';
import { CommonModule } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-view-image-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconButton,
    MatIcon,
    MatTooltip
  ],
  templateUrl: './view-image-dialog.component.html',
  styleUrl: './view-image-dialog.component.scss'
})

export class ViewImageDialogComponent {

  selectedImageUrl: string;
  type: AttachmentType;
  showFullScale = false;
  constructor(
    public dialogRef: MatDialogRef<ViewImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ViewImageDialog,
    private alertService: AlertService
  ) {
    // Update view with given values
    this.selectedImageUrl = data.selectedImageUrl;
    this.type = data.type;
  }

  ngOnInit(): void {}

  // async delete() {
  //   if (!this.hideConfirm) {
  //     const confirmation = await this.alertService.confirm(
  //       'Delete',
  //       `Are you sure? This is irreversible!!`
  //     );
  //     if (!confirmation) return;
  //   }
  //   this.dialogRef.close({
  //     action: 'delete',
  //   });
  // }

  // restore() {
  //   this.dialogRef.close({
  //     action: 'restore',
  //   });
  // }

  closeDialog() {
    this.dialogRef.close();
  }
}

export class ViewImageDialog {
  constructor(
    public selectedImageUrl: string,
    public type: AttachmentType,
  ) {}
}